import React, { useEffect, useState } from 'react';
import { useOutletContext } from 'react-router';
import AppBar from '@Components/AppBar';
import IconButton from '@Components/IconButton';
import questionMarkIcon from 'assets/icons/question_mark_icon.svg';
import Button from '@Components/Button';
import ReviewDialog from './components/ReviewDialog';
import { formatCurrency } from '@Utilities/services/currency';
import Footer from 'components/common/Footer';
import EmbarkGiftImg from 'assets/images/embark_gifting.png';
import { logComponentEvent } from '@Utilities/services/logging/componentEvent';
import { useBrowserHistory } from '@Utilities/services/hooks/useBrowserHistory';
import './styles/giftReview.scss';

export default function GiftReview() {
  const {
    locale,
    localized,
    beneficiary,
    selectedGiftAmount,
    totalProcessingFee,
    checkoutMessage,
    isPaymentLoading,
    submitCheckout,
    selectedOccasion
  } = useOutletContext();

  const { firstName } = beneficiary || {};
  const formattedFee = (totalProcessingFee / 100);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const browserHistory = useBrowserHistory();

  useEffect(() => {
    logComponentEvent('GiftingReview', 'PageLoaded');
  }, []);

  return (
    <div className='gift-review'>
      <div className='gift-review__content'>
        <div className='gift-review__content__left'>
          <AppBar
            title={localized[`gifting.review.header`]}
            className='gift-review__content__left__toolbar'
            onBackClick={() => {
              browserHistory.push('/gift/compliance');
            }}
          />
          <img
            src={selectedOccasion?.cardImage || EmbarkGiftImg}
            alt={
              selectedOccasion?.cardImageAlt || localized['img.alt.embarkGift']
            }
            className='gift-review__content__left__img'
          />
          {selectedOccasion?.cardLabel && (
            <span className='gift-review__content__left__img__label'>
              {selectedOccasion.cardLabel || ''}
            </span>
          )}
        </div>
        <div className='gift-review__content__right'>
          <div className='gift-review__content__right__name'>
            <div className='gift-review__content__right__name__label'>
              {localized['gifting.review.name']}
            </div>
            <div className='gift-review__content__right__name__text'>
              {firstName}
            </div>
          </div>
          <div className='gift-review__content__right__amount'>
            <div className='gift-review__content__right__amount__label'>
              {localized['gifting.review.amount']}
            </div>
            <div className='gift-review__content__right__amount__text'>
              {formatCurrency(selectedGiftAmount, locale)}
            </div>
          </div>
          <div className='gift-review__content__right__fee'>
            <div className='gift-review__content__right__fee__label'>
              {localized[`gifting.review.processingFee`]}
              <IconButton
                onClick={() => {
                  setIsDialogOpen(true);
                }}
              >
                <img src={questionMarkIcon} />
              </IconButton>
            </div>
            <span className='gift-review__content__right__fee__text'>
              +{formatCurrency(formattedFee)}
            </span>
          </div>
          <div className='gift-review__content__right__total'>
            <div className='gift-review__content__right__total__label'>
              {localized[`gifting.review.total`]}
            </div>
            <span className='gift-review__content__right__total__text'>
              {formatCurrency(selectedGiftAmount + formattedFee, locale)}
            </span>
          </div>
          <div className='gift-review__content__right__message'>
            <div className='gift-review__content__right__message__label'>
              {localized[`gifting.review.message`]}
            </div>
            <div className='gift-review__content__right__message__textbox'>
              {checkoutMessage || '-'}
            </div>
          </div>
          <Button
            size='large'
            variant='tonal'
            className='gift-review__content__right__btn'
            isLoading={isPaymentLoading}
            onClick={submitCheckout}
            style={{ ...(locale === 'fr-CA' ? { padding: '1rem' } : {}) }}
          >
            {localized['gifting.review.button']}
          </Button>
          <ReviewDialog
            isOpen={isDialogOpen}
            localized={localized}
            onClose={() => {
              setIsDialogOpen(false);
            }}
          />
          <Footer />
        </div>
      </div>
    </div>
  );
};
